/**
 * AccesosRapidos: Fila horizontal de 4-6 cards con iconos que llevan a
 * secciones/filtros específicos de la Guía TS+ (estilo Bonda).
 */
import React from 'react';
import { Sparkles, Star, TrendingUp, Palmtree, Compass } from 'lucide-react';

const ITEMS_DEFAULT = [
  {
    id: 'novedades',
    titulo: 'Novedades',
    subtitulo: 'Últimos incorporados',
    icon: Sparkles,
    color: 'from-amber-400 to-orange-500',
    iconColor: 'text-amber-500',
  },
  {
    id: 'destacados',
    titulo: 'Destacados',
    subtitulo: 'Elegidos por el Colegio',
    icon: Star,
    color: 'from-purple-500 to-purple-700',
    iconColor: 'text-purple-500',
  },
  {
    id: 'populares',
    titulo: 'Los más usados',
    subtitulo: 'Últimos 90 días',
    icon: TrendingUp,
    color: 'from-emerald-500 to-teal-600',
    iconColor: 'text-emerald-500',
  },
  {
    id: 'turismo',
    titulo: 'Turismo social',
    subtitulo: 'Rueda del Colegio',
    icon: Palmtree,
    color: 'from-sky-500 to-blue-600',
    iconColor: 'text-sky-500',
  },
  {
    id: 'todos',
    titulo: 'Todos',
    subtitulo: 'Explorar toda la guía',
    icon: Compass,
    color: 'from-fuchsia-500 to-pink-600',
    iconColor: 'text-fuchsia-500',
  },
];

export default function AccesosRapidos({ onSelect, items = ITEMS_DEFAULT }) {
  return (
    <div className="overflow-x-auto -mx-2 px-2 pb-2 scrollbar-thin" data-testid="accesos-rapidos">
      <div className="grid grid-cols-2 sm:flex sm:justify-between gap-3 sm:min-w-full">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => onSelect(item.id)}
              className="group flex-1 min-w-[140px] sm:min-w-0 flex sm:flex-col items-center sm:items-start gap-3 sm:gap-2 bg-white rounded-2xl border border-gray-200 hover:border-purple-400 hover:shadow-md transition-all p-3 sm:p-4 text-left"
              data-testid={`acceso-rapido-${item.id}`}
            >
              <div
                className={`w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform flex-shrink-0`}
              >
                <Icon className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-900 text-sm leading-tight line-clamp-1">
                  {item.titulo}
                </p>
                <p className="text-[10px] sm:text-[11px] text-gray-500 mt-0.5 leading-tight line-clamp-1">
                  {item.subtitulo}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
